import React from 'react';
import './App.css';
import TodoApp from './TodoApp';

function App() {
  return <TodoApp />;
}

export default App;
